module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_cross-944a451f36f21c980e93894fe605298c.svg";